import { createFocusTrap } from 'focus-trap'
import clickOutside from 'click-outside'

const toggleableElement = (options) => {
  const { button, dropdown, hiddenClass } = options
  const buttonEl = document.querySelector(button)
  const dropdownEl = document.querySelector(dropdown)

  const focusTrap = createFocusTrap(dropdownEl, {
    clickOutsideDeactivates: true,
  })

  const handleToggle = () => {
    // toggle element on
    if (dropdownEl.classList.contains(hiddenClass)) {
      dropdownEl.classList.remove(hiddenClass)
      return focusTrap.activate()
    }

    // toggle element off
    dropdownEl.classList.add(hiddenClass)
    return focusTrap.deactivate()
  }

  // Click event
  if (buttonEl){
    buttonEl.addEventListener('click', (e) => handleToggle())
  }

  // Click outside event
  clickOutside(dropdownEl, (e) => {
    if (
      e.target !== buttonEl &&
      dropdownEl.classList.contains(hiddenClass) === false
    ) {
      handleToggle()
    }
  })

  // Keyboard events
  document.addEventListener('keydown', (e) => {
    if (
      (e.key === 'Escape' || e.keyCode === 27) &&
      dropdownEl.classList.contains(hiddenClass) === false
    ) {
      handleToggle()
    }
  })

  return {
    handleToggle,
  }
}

export default toggleableElement
